import { useMutation } from '@tanstack/react-query';
import { JsonObject } from 'type-fest';

import type { MutationFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

export type UseUpdateOperationData = {
  id: number;
  componentId: number;
  opDefId: number;
} & JsonObject;

export type UseUpdateOperationRequestVars = {
  operationId: number;
  isFinish?: boolean;
};

export const useUpdateOperation: MutationFunction<
  UseUpdateOperationData,
  UseUpdateOperationRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: ({ operationId, ...body }) =>
      request(`/quotes/components/operations/${operationId}`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }),
    ...queryOptions,
  });
};
